import { useModel, useRoute } from "@bcm-dev/bcms-vite";
import ButtonContainer from 'compid/shared/containers/ButtonContainer';
import PageLayoutContainer from 'compid/shared/containers/PageLayoutContainer';
import CenterColumnContainer from 'compid/shared/containers/PageLayoutContainer/containers/CenterColumnContainer';
import PageView from 'compid/shared/containers/PageViewContainer';
import UIButton from 'compid/ui/UIButton';
import React from 'react';
import { SVGAsset } from 'res';
import './styles.css';


/**
 * @function FirstTimeUserWelcomePage
 * @param {String} className - Allows us to set a custom class name for the component
 * @return {React.Component}
 * @exported true
 * @description The Welcome Page that shows for first time users
 */

export default function FirstTimeUserWelcomePage(props) {
  const { branding, profile, settings } = useModel();
  const { options } = branding;
  const { name } = profile;
  const { fiName } = settings;
  const hasBillDiscovery = options.bill_discovery_rxp22 === "true";
  const navigate = useRoute();
  const onGetStartedClick = () => navigate(hasBillDiscovery ? "/billDiscoveryWorkflow" : "/paybills");

  return(
    <PageView className="first-time-user-welcome-page">
        <p className="page-sub-header semi-bold-text">{ `WELCOME, ${ name }` }</p>

        <PageLayoutContainer>
          <CenterColumnContainer>
            <h1 className="welcome-page-header text-center">{ `Simplify your bill pay routine with ${ fiName } Bill Payment!` }</h1>

            <div className="flex-container flex-horizontal align-left welcome-item-container convenience-container">
              <div className="icon-circle-container flex-container align-center">
                <SVGAsset id="LaptopIcon" className="welcome-icon convenience-icon" />
              </div>
              <div className="text-container">
                <h2 className="convenience-header">Convenience</h2>
                <p className="welcome-item-text convenience-text">Say goodbye to the hassle of juggling multiple passwords and accounts. Now, you can conveniently pay all your bills anytime, anywhere, on any device.</p>
              </div>
            </div>

            <div className="flex-container flex-horizontal align-left welcome-item-container real-time-container">
              <div className="icon-circle-container flex-container align-center">
                <SVGAsset id="WalletIcon" className="welcome-icon real-time-icon" />
              </div>

              <div className="text-container">
                <h2 className="convenience-header">Real-time balance updates</h2>
                <p className="welcome-item-text convenience-text">Your balance updates instantly with every payment. See the exact dates for debit and delivery times with instant notifications if there's a problem.</p>
              </div>
            </div>

            <div className="flex-container flex-horizontal align-left welcome-item-container faster-payments-container">
              <div className="icon-circle-container flex-container align-center">
                <SVGAsset id="ZapIcon" className="welcome-icon zap-icon" />
              </div>

              <div className="text-container">
                <h2 className="convenience-header">Faster payments</h2>
                <p className="welcome-item-text convenience-text">Pay your bills immediately or same day for eligible billers. Just look for the "{<SVGAsset id="ZapIcon" />}" in the Pay button to find billers that support faster delivery (immediate or same day).</p>
              </div>
            </div>

            <div className="flex-container flex-horizontal align-left welcome-item-container control-container">
              <div className="icon-circle-container flex-container align-center">
                <SVGAsset id="ClockNotebookIcon" className="welcome-icon control-icon" />
              </div>
              <div className="text-container">
                <h2 className="control-header">Control</h2>
                <p className="welcome-item-text control-text">Receive electronic bill statements directly to your account,eliminating paper clutter and streamlining your financial record-keeping.</p>
                <p className="control-text bottom-text">Set up customizable reminders and automatic payments to ensure you never miss a due date again.</p>
              </div>
            </div>
            <div className="flex-container flex-horizontal align-left welcome-item-container guidance-container">
              <div className="icon-circle-container flex-container align-center">
                <SVGAsset id="QuestionCircleOutlineIcon" className="welcome-icon question-mark-circles-icon" />
              </div>
              <div className="text-container">
                <h2 className="guidance-header">Guidance</h2>
                <p className="welcome-item-text guidance-text">Need help how to use a feature in billpay? Help guides are available for certain features, click on the question mark icon to learn more.</p>
              </div>
            </div>
            <ButtonContainer className="form-button-container single-button-container">
              <UIButton className="primary-button" onClick={ onGetStartedClick }>Get started</UIButton>
            </ButtonContainer>
          </CenterColumnContainer>
        </PageLayoutContainer>
    </PageView>
  );
}